import { Provider } from '@repo/api-gw-sdk';

import type { RestoreAzureVMState } from './restoreAzureVMWizard';
import type { RestoreEc2InstanceState } from './restoreEc2InstanceWizard';
import type { RestoreGcpVMState } from './restoreGcpVMWizard';
import { AzureVmConfiguration } from './steps/azureVmConfiguration';
import { GcpVmConfiguration } from './steps/gcp/gcpVmConfiguration';
import { InstanceConfiguration } from './steps/instanceConfiguration';

import type { StepProps } from '../wizard/StepProps';

export const CrossCloudInstanceAdapter = (
  props:
    | StepProps<RestoreEc2InstanceState>
    | StepProps<RestoreAzureVMState>
    | StepProps<RestoreGcpVMState>
) => {
  const cloudProvider =
    props.wizardState.restoreAccount?.restoreAccountAttributes.cloudProvider;
  if (cloudProvider === Provider.Aws) {
    return (
      <InstanceConfiguration
        {...(props as StepProps<RestoreEc2InstanceState>)}
      />
    );
  }

  if (cloudProvider === Provider.Azure) {
    return (
      <AzureVmConfiguration {...(props as StepProps<RestoreAzureVMState>)} />
    );
  }

  if (cloudProvider === Provider.Gcp) {
    return <GcpVmConfiguration {...(props as StepProps<RestoreGcpVMState>)} />;
  }

  return null;
};
